<template>
  <div class="tiaolimenu between">
    <taolimenulist class="menu" :menulist="tlmenuL"  />
    <recomlayadv class="recomlay" />
  </div>
</template>

<script>
import recomlayadv from "../components/recomlayadv";
import taolimenulist from "../components/taolimenulist";
export default {
  props:['tlmenuL'],
  components: {
    recomlayadv,
    taolimenulist
  },
  data(){
    return {}
  },
};
</script>

<style lang="scss" scoped>
.tiaolimenu {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  align-items: flex-start;
  .menu {
    width: 880px;
    height: 534px;
  }
  .recomlay {
    width: 270px;
    height: 534px;
    box-shadow: 0px 2px 15px 0px rgba(1, 1, 1, 0.1);
  }
}
</style>